const getWithKey = (obj, key) => obj[key];
export {
  getWithKey
};
//# sourceMappingURL=helpers.js.map
